import React from "react";
import { Box, Button } from "@mui/material";
import { Download } from "@mui/icons-material";

const ArchivedReportTableToolbar = ({ reports, downloadReports }) => {
  return (
    <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, p: 1 }}>
      <Button
        color="secondary"
        variant="outlined"
        disabled={!reports?.length}
        onClick={() => downloadReports(false)}
        startIcon={<Download />}
      >
        Download
      </Button>
      <Button
        color="secondary"
        variant="outlined"
        disabled={!reports?.length}
        onClick={() => downloadReports(true)}
        startIcon={<Download />}
      >
        Download Reports
      </Button>
    </Box>
  );
};

export default ArchivedReportTableToolbar;
